import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Prevent React app from initializing on VitePress docs routes
// VitePress docs are deployed to /docs/ subdirectory in production
const currentPath = window.location.pathname;

if (currentPath.startsWith('/docs/') || currentPath === '/docs') {
  // On docs routes, let the web server handle the request
  // This prevents React Router's wildcard route from intercepting docs pages
  console.log('[React] Detected docs route, skipping React initialization:', currentPath);

  // Optional: Display a fallback message if static files aren't loading
  // This helps with debugging in case of deployment issues
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100vh; font-family: system-ui, -apple-system, sans-serif; padding: 2rem;">
        <h2 style="color: #374151; margin-bottom: 1rem;">Loading documentation...</h2>
        <p style="color: #6b7280; margin-bottom: 2rem;">If this message persists, the VitePress documentation may not be properly deployed.</p>
        <a href="/" style="color: #2563eb; text-decoration: underline;">← Return to main application</a>
      </div>
    `;
  }
} else {
  // Normal React app initialization for all other routes
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
